import { isEmpty } from 'lodash';

import { strapiAssetBaseUrl } from '../../../config/routes/assets';
import { pageRoute } from '../../../config/routes/pages';
import { NewsAndEventsModel } from '../../../interface/news-and-events';
import { FriendsOfTheKitchenPageDetailsType } from '../../../types/content';
import FeaturedCard from '../../atoms/featured-card/featured-card';
import Sidebar from '../../organisms/sidebar/sidebar';
import FeaturedCardsWrapper from '../featured-cards-wrapper/featured-cards-wrapper';

/* eslint-disable-next-line */
type FeaturesSidebarProps = {
  hasSidebar?: boolean;
  isReversed?: boolean;
  friendsOfTheKitchenPageDetails?: FriendsOfTheKitchenPageDetailsType[];
  newsAndEventsContent: NewsAndEventsModel[];
};

export function FeaturesSidebar(props: FeaturesSidebarProps) {
  const {
    isReversed = false,
    friendsOfTheKitchenPageDetails = [],
    newsAndEventsContent
  } = props;

  const featuredNewsCards = newsAndEventsContent.map((newsItem) => {
    return (
      <FeaturedCard
        ctaLink={`${pageRoute.NEWS_AND_EVENTS_ONLY}/${newsItem.attributes.slug}`}
        key={newsItem.id}
        src={newsItem.attributes.news_image.data.attributes.url}
        title={newsItem.attributes.news_title}
      />
    );
  });

  const customFeaturedNewsCards = [
    <FeaturedCard
      ctaLink="26801"
      key="101"
      src={`${strapiAssetBaseUrl}/1_8be5194c8b.jpg`}
      title="Summer in the Hamptons"
    />,
    ...featuredNewsCards.slice(0, 2)
  ];

  const featuredNewsContent = (
    <FeaturedCardsWrapper
      ctaLink={pageRoute.NEWS_AND_EVENTS}
      title="NEWS AND EVENTS"
    >
      {customFeaturedNewsCards}
    </FeaturedCardsWrapper>
  );

  const featuredFriendsOfTheKitchen = friendsOfTheKitchenPageDetails.map(
    (pageItem) => {
      return (
        <FeaturedCard
          ctaLink={`${pageRoute.FRIENDS_OF_KITCHEN}/${pageItem.slug}`}
          key={pageItem.pageTitle}
          src={pageItem.mainImage}
          subtitle={pageItem.subtitle}
          title={pageItem.pageTitle}
        />
      );
    }
  );

  const featuredFriendsOfTheKitchenContent = (
    <FeaturedCardsWrapper
      ctaLink={pageRoute.FRIENDS_OF_KITCHEN}
      title="FEATURES"
    >
      {featuredFriendsOfTheKitchen}
    </FeaturedCardsWrapper>
  );

  const sidebarSection = isEmpty(friendsOfTheKitchenPageDetails) ? (
    <Sidebar />
  ) : (
    featuredFriendsOfTheKitchenContent
  );

  const reversedStyle = isReversed ? 'flex-col-reverse' : 'flex-col';

  return (
    <div className={`flex ${reversedStyle} px-4`}>
      {featuredNewsContent}
      <hr className="solid my-5" />
      {sidebarSection}
    </div>
  );
}

export default FeaturesSidebar;
